import { type CSSProperties, type FC } from "react";

import { nonBreakingSpace } from "@/settings/settings.js";

import { type IAgGridCellProps } from "../../cell-base-interfaces.js";
import ListCellContent, { type ListCellItem } from "./ListCellContent.js";
import { TableCell } from "./TableCell.js";

interface ITextCellProps {
  style?: CSSProperties;
  classname?: string;
  tooltip?: string;
}

/**
 * Converts a simple text string into {@link ListCellItem}s.
 */
const TableCellText: FC<IAgGridCellProps & ITextCellProps> = (props) => {
  const finalValue = props.valueFormatted || props.value;
  if (finalValue == undefined || finalValue === "" /* make sure the 0 value is valid */) {
    return null;
  }
  const multiValues: string[] = finalValue instanceof Array ? finalValue : [finalValue];

  // SEL6-2659: Make sure null values result in empty lines in the table cell by translating them to &nbsp (\u00A0);
  const items: ListCellItem[] = multiValues.map((v) => {
    /* since the nested_list_string is also bound to this TableCellText, the value might be a sub list */
    const stringValue = Array.isArray(v) ? v.join(", ") : v;
    const listCellItem: ListCellItem = {
      value: stringValue == undefined || stringValue?.trim?.() == "" ? nonBreakingSpace : stringValue,
      tooltip: props.tooltip || stringValue || nonBreakingSpace,
    };
    return listCellItem;
  });

  return (
    <TableCell>
      <ListCellContent items={items} colDef={props.colDef} style={props.style} context={props.context} />
    </TableCell>
  );
};

export default TableCellText;
